import PublicHeader from "../components/PublicHeader";
import "./css/Privacy.css";

export default function PrivacyPolicyPage() {
  return (
    <div className="privacy-page">
      <PublicHeader />

      <div className="privacy-content-wrapper">
        <div className="privacy-card">
          <h1>Política de Privacidade</h1>

          <p className="privacy-intro">
            A sua privacidade é importante para nós. Esta política descreve como o
            MesaClick coleta, usa, armazena e protege os seus dados pessoais ao
            utilizar nossa plataforma (site institucional, tela de cadastro,
            painel de gestão do restaurante e demais serviços relacionados).
          </p>

          <h2>1. Coleta de Informações</h2>
          <p>
            Coletamos informações pessoais apenas quando realmente precisamos delas
            para lhe fornecer um serviço. Isso inclui, por exemplo:
          </p>
          <ul>
            <li>Dados de cadastro (nome, e-mail, telefone);</li>
            <li>Dados do restaurante (razão social, CNPJ, endereço, contato);</li>
            <li>
              Dados de uso da plataforma (horários de acesso, telas acessadas, ações
              relevantes para auditoria e segurança);
            </li>
            <li>
              Informações técnicas básicas (endereço IP, tipo de navegador, sistema
              operacional) para fins de segurança e melhoria do serviço.
            </li>
          </ul>
          <p>
            Todas as informações são coletadas por meios justos e legais, com o seu
            conhecimento e consentimento, e sempre informamos o motivo da coleta e
            como os dados serão utilizados.
          </p>

          <h2>2. Uso das Informações</h2>
          <p>Utilizamos seus dados pessoais para:</p>
          <ul>
            <li>Permitir o cadastro e acesso à plataforma MesaClick;</li>
            <li>Configurar e gerenciar o restaurante na plataforma;</li>
            <li>Oferecer suporte técnico e atendimento ao cliente;</li>
            <li>
              Enviar comunicações importantes sobre o uso do sistema, alterações de
              planos, segurança e melhorias;
            </li>
            <li>
              Melhorar a experiência de uso da plataforma, bem como monitorar
              desempenho e estabilidade do serviço.
            </li>
          </ul>

          <h2>3. Retenção e Proteção dos Dados</h2>
          <p>
            Apenas retemos as informações coletadas pelo tempo necessário para
            fornecer o serviço solicitado ou para cumprir obrigações legais e
            regulatórias.
          </p>
          <p>
            Quando armazenamos dados, protegemos dentro de meios comercialmente
            aceitáveis para evitar perdas, roubos, acesso indevido, divulgação,
            cópia, uso ou modificação não autorizados.
          </p>

          <h2>4. Compartilhamento de Informações</h2>
          <p>
            Não compartilhamos informações de identificação pessoal publicamente ou
            com terceiros, exceto:
          </p>
          <ul>
            <li>
              Quando isso for necessário para a prestação do serviço (por exemplo,
              provedores de infraestrutura, hospedagem ou ferramentas de e-mail);
            </li>
            <li>Quando você autorizar expressamente o compartilhamento;</li>
            <li>Quando exigido por lei, ordem judicial ou autoridade competente.</li>
          </ul>

          <h2>5. Links para Sites de Terceiros</h2>
          <p>
            A plataforma MesaClick pode conter links para sites externos que não são
            operados por nós. Não temos controle sobre o conteúdo e práticas desses
            sites e não podemos nos responsabilizar por suas respectivas políticas
            de privacidade. Recomendamos que você leia as políticas de privacidade
            desses serviços antes de fornecer qualquer informação pessoal.
          </p>

          <h2>6. Cookies e Tecnologias de Rastreamento</h2>
          <p>
            Podemos utilizar cookies e tecnologias semelhantes para melhorar a
            experiência de navegação, lembrar preferências e entender como a
            plataforma está sendo utilizada.
          </p>
          <p>
            Atualmente, o MesaClick não utiliza serviços de publicidade de terceiros
            como Google AdSense na plataforma de gestão, mas poderemos utilizar
            cookies de análise (analytics) para fins estatísticos e de melhoria
            contínua do sistema.
          </p>
          <p>
            Você pode configurar seu navegador para bloquear cookies, porém isso
            pode impactar algumas funcionalidades da plataforma.
          </p>

          <h2>7. Seus Direitos</h2>
          <p>
            Você é livre para recusar a nossa solicitação de informações pessoais,
            entendendo que, nesse caso, talvez não possamos fornecer algumas partes
            do serviço (como acesso ao painel do restaurante).
          </p>
          <p>
            Você pode solicitar, a qualquer momento, a atualização, correção ou
            exclusão de seus dados pessoais, respeitando limites legais e
            regulamentares aplicáveis.
          </p>

          <h2>8. Compromisso do Usuário</h2>
          <p>Ao utilizar o MesaClick, o usuário se compromete a:</p>
          <ul>
            <li>
              Não se envolver em atividades ilegais ou contrárias à boa-fé e à
              ordem pública;
            </li>
            <li>
              Não difundir conteúdo de natureza racista, xenofóbica, discriminatória,
              violenta, pornográfica ilegal, de apologia ao crime, terrorismo ou
              contra os direitos humanos;
            </li>
            <li>
              Não causar danos aos sistemas físicos (hardware) e lógicos (software)
              do MesaClick, de seus fornecedores ou de terceiros;
            </li>
            <li>
              Não introduzir ou disseminar vírus, malware ou quaisquer outros
              sistemas capazes de causar danos aos nossos serviços ou à infraestrutura
              de terceiros.
            </li>
          </ul>

          <h2>9. Contato</h2>
          <p>
            Em caso de dúvidas sobre como tratamos dados pessoais ou sobre esta
            Política de Privacidade, você pode entrar em contato conosco pelos
            seguintes canais:
          </p>
          <ul>
            <li>
              <a className="bi bi-whatsapp" href="https://wa.me/5567999077564" target="_blank"> WhatsApp
                    </a>
             
            </li>
            <li>
              <a className="bi bi-envelope contact-icon" href="mailto:contato@faenetech.com.br"> E-mail
                    </a>
            </li>
          </ul>

          <h2>10. Atualizações desta Política</h2>
          <p>
            Podemos atualizar esta Política de Privacidade periodicamente para
            refletir melhorias na plataforma, alterações legais ou ajustes nos
            processos de tratamento de dados.
          </p>
          <p>
            O uso continuado do MesaClick após a publicação de alterações será
            considerado como aceitação das novas práticas de privacidade.
          </p>

          <p className="privacy-effective-date">
            Esta política é efetiva a partir de <strong>27 de Janeiro de 2024</strong>.
          </p>
        </div>
      </div>

      <footer className="privacy-footer">
        © {new Date().getFullYear()} MesaClick — Desenvolvido por Faenetech Sistemas e Tecnologia
      </footer>
    </div>
  );
}
